export const imageCodes = {
    about: {
        code: "${merchantId}_tmpl_img_24",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabo.png?alt=media&token=33cc1e1f-73e0-4555-beea-1ab9a8f754be"
    },

}

export const titleCodes = {
    aboutTitle: {
        code: "${merchantId}_tmpl_title_3",
        title: "ABOUT "
    },

   
}
//
export const textCodes = {
    about: {
        code: "${merchantId}_tmpl_text_2",
        text: "ENCORE has been established since 2020 by 2 friends who are interested in street and grunge fashion. The type and style of clothing we wanted to wear was not available in our country at the time, so we started to develop and sell it our own. Many teenage liked and encouraged us, so we thought of better ideas and were able to sell better products. The style and feelings we want to give to people is independent, youthful, and wild and kind of street-style."
    },

    about1: {
        code: "${merchantId}_tmpl_text_3",
        text: "‘Do what you like and don't care about anything.’ As long as it doesn't hurt anyone, you have the right to express what you like. It's as simple as that’’. This is our quote and our goal is to make our brand to be something that every young person dreams of. We will try until every people's thoughts beg for more and more every single day from us."
    },

    
}
export const videoCodes = {
    video1: {
        code: "${merchantId}_tmpl_video_2",
        video: "https://www.youtube.com/embed/2Wo-snB62Q0?autoplay=1"
    }
}